var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnyCropped3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "104px",
    height: "78px",
    viewBox: "3 0 104 57",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.97,
    fill: "#FFC72A",
    d: "M1.15434 0.70586L0.185791 0.712524L0.343261 23.599L18.4523 23.4744L18.4523 23.4743C16.2019 23.4916 13.9693 22.9164 11.8819 21.7815C9.79445 20.6465 7.8932 18.974 6.28677 16.8596C4.68035 14.7451 3.40024 12.2302 2.5196 9.45841C1.63897 6.68671 1.17505 3.71254 1.15434 0.70586Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.97,
    fill: "#FFC72A",
    d: "M3.20263 52.8389L0.570068 52.8571L0.400127 28.158L23.3816 27.9999L23.3819 28.0443C20.9843 28.2234 18.6272 28.8578 16.4084 29.9245C13.7909 31.1829 11.4172 33.0183 9.42291 35.3258C7.4286 37.6334 5.85277 40.3679 4.78546 43.373C3.71828 46.3779 3.18042 49.5944 3.20263 52.8389Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.97,
    fill: "#FFC72A",
    transform: "rotate(-0.394217 0.344482 23.3745)",
    height: 5.00661,
    width: 113,
    y: 23.3745,
    x: 0.344482
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnyCropped3);
export default __webpack_public_path__ + "static/media/any-cropped (3).5029592781ca6941cb754919845a30f7.svg";
export { ForwardRef as ReactComponent };